
<div *ngIf="checkViewMode('edit')">
</div>

<div *ngIf="checkViewMode('view')" class="qrcode">
    <qrcode [qrdata]="getValue()" [elementType]="img" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
</div>